"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var NewLineHelper = /** @class */ (function () {
    function NewLineHelper() {
    }
    NewLineHelper.convertToBreaks = function (text) {
        var newline = String.fromCharCode(13, 10);
        return text.replace("\n", newline);
    };
    return NewLineHelper;
}());
exports.default = NewLineHelper;
//# sourceMappingURL=newLineHelper.js.map


/** WEBPACK FOOTER **
 ** ./src/utils/newLineHelper.js
 **/